module.exports = __webpack_public_path__ + "static/media/mobile-mask@3x.868518fd.png";